<template>
  <div class="editor-container h-screen flex flex-col noSelect">
    <!-- Toolbar -->
    <Toolbar
      class="flex-shrink-0 z-10"
      :pageSelection="true"
    />
    <!-- Editor content -->
    <div class="flex-1 flex min-h-0">
      <!-- Sidebar -->
      <aside 
        class="sidebar-container bg-gray-800"
      >
        <Sidebar/>
      </aside>
      
      <!-- Preview area -->
      <main 
        class="flex-1 overflow-auto md:block relative flex items-center justify-center"
      >
        <div class="preview-wrapper flex items-center justify-center p-4 min-h-full">
          <PreviewArea ref="previewArea"/>
        </div>
      </main>
      
      <!-- Properties panel -->
      <aside 
        class="sidebar-properties bg-gray-800"
        :class="{'close': !currentElement}"
      >
        <PropertiesPanel/>
      </aside>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import Toolbar from '../components/Toolbar.vue'
import Sidebar from '../components/editor/Sidebar.vue'
import PreviewArea from '../components/editor/PreviewArea.vue'
import PropertiesPanel from '../components/editor/PropertiesPanel.vue'
import * as namespaceStore from "../vuexStore/namespaceStore.js"
import * as actions from "../vuexStore/actions.js"
import * as mutates from "../vuexStore/mutations.js"

export default {
  name: 'Editor',
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (!vm.hasCurrentTheme) {
        vm.createDefaultTheme();
      }
    })
  },
  components: {
    Toolbar,
    Sidebar,
    PreviewArea,
    PropertiesPanel,
  },
  data() {
    return {
    }
  },
  computed: {
    ...mapGetters(namespaceStore.THEME, [
      'hasCurrentTheme',
      'currentElement',
    ]),
  },
  created() {
  },
  mounted() {
    document.addEventListener("keydown", this.escapeEvent);
  },
  beforeUnmount() {
    document.removeEventListener("keydown", this.escapeEvent);
  },
  methods: {
    ...mapMutations(namespaceStore.THEME, {
      unSelectElement: mutates.UNSELECT_ELEMENT,
    }),
    ...mapActions(namespaceStore.THEME, {
      createDefaultTheme: actions.CREATE_DEFAULT_THEME,
    }),
    escapeEvent: function(event) {
      if (event.key == "Escape")
        this.unSelectElement();
    }
  }
}
</script>

<style>
.sidebar-properties {
  transition: all 0.3s ease;
  overflow-x: hidden;
  overflow-y: auto;
  border: 1px solid #a4a4a4;
  border-radius: 5px 5px 5px 5px;
  margin: 10px 10px 10px 0px;
  width: 22%;
  min-width: 300px;
  transition: all 0.3s ease;
}

.sidebar-properties.close {
  transform: translateX(110%);
}

.editor-container {
  height: 100%;
  width: 100%;
  flex: 1;
  overflow: hidden;
}

.sidebar-container {
  border: 1px solid #a4a4a4;
  border-radius: 5px 5px 5px 5px;
  width: 300px;
  margin: 10px 0px 10px 10px;
  overflow-y: auto;
}

/* Container de prévisualisation */
.preview-wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Styles pour améliorer la responsivité et l'échelle du prévisualisateur */
main .preview-container {
  transform: scale(0.5);
  transform-origin: center;
  transition: transform 0.3s ease;
  border-radius: 8px;
}

/* Masquer la scrollbar pour Chrome, Safari et Opera */
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-track {
  @apply bg-gray-800;
}

::-webkit-scrollbar-thumb {
  @apply bg-gray-600 rounded;
}

::-webkit-scrollbar-thumb:hover {
  @apply bg-gray-500;
}

/* Styles de scrollbar pour Firefox */
* {
  scrollbar-width: thin;
  scrollbar-color: #4B5563 #1F2937;
}

@media (min-width: 768px) {
  .editor-content > * {
    display: block !important;
  }
}
</style> 